export const choiceOfSeo = (staticMetaPropsArray: any, category: string) => (
  staticMetaPropsArray.filter((el: { type: string }) => el.type === category)[0].data
);
